const getUsedTerms = ({ terms, posts, taxonomy }) => {
    return terms.filter(term => {
        return posts.find(post => post[taxonomy].includes(term.id)) ? true : false
    })
}

const TermOption = ({ slug = '', name = '' } = {}) => (<option value={slug}>{name}</option>)

const TermOptions = ({
    defaultOptionLabel = 'Choose an option',
    terms,
    posts,
    taxonomy
}) => {
    return (
        <>
            <option value="-1">{defaultOptionLabel}</option>
            {
                getUsedTerms({ terms, posts, taxonomy }).map(TermOption)
            }
        </>
    )
}

const SalsaSelect = (props = {}) => {
    const {
        label,
        name,
        children
    } = props
    return (
        <div class="gap-2 grid">
            <label class="font-semibold text-xs uppercase">{label}<span class="frm_required"></span></label>
            <select aria-invalid="false" name={name} class="border-0 border-b-1 duration-100 focus:px-2 font-normal px-0 text-base text-gray-darkest transition-all w-full">
                {children}
            </select>
        </div>
    )
}

export function EventsFinderForm(props) {
    const {
        roles,
        eventTypes,
        countries,
        languages,
        events
    } = props

    return (
        <form method="GET" action="/all-events">
            <div>
                <fieldset>
                    <div class="gap-9 grid">
                        <SalsaSelect label="What is your role?" name="role">
                            <TermOptions terms={roles} posts={events} taxonomy="role" />
                        </SalsaSelect>

                        <SalsaSelect label="Event Type" name="event_types">
                            <TermOptions terms={eventTypes} posts={events} taxonomy="event_types" />
                        </SalsaSelect>

                        <SalsaSelect label="Locations" name="country">
                            <TermOptions terms={countries} posts={events} taxonomy="country" />
                        </SalsaSelect>

                        <SalsaSelect label="Language" name="language">
                            <TermOptions terms={languages} posts={events} taxonomy="language" />
                        </SalsaSelect>
                        <button type="submit" class="button">Find events</button>
                    </div>
                </fieldset>
            </div>
        </form>
    );
}

export default EventsFinderForm;
